import { Vue } from 'vue-property-decorator'
import { create } from 'mobx-persist'

export default {
  /**
     * Install the System request class.
     *
     * @param {Object} Vue The global Vue.
     * @param {Object} options Any options we want to have in our plugin.
     * @return {void}
     */
  install (Vue) {
    Vue.prototype.$mobx = Vue.mobx = this
  }
}
const hydrate = create({
  storage: localStorage,
  jsonify: true
})
export const JtechStore = {
  getSingleton: function (store, instance, loadStorage) {
    if (Vue.prototype.$mobx[store]) {
      return Vue.prototype.$mobx[store]
    }
    Vue.prototype.$mobx[store] = instance
    if (loadStorage) {
      hydrate(store, Vue.prototype.$mobx[store])
    }
    return Vue.prototype.$mobx[store]
  }

}
